export default "__VITE_ASSET__DsUoQSaj__"